import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { residualsCommonService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useGetResidualsStagesStatusQuery = ({ paidYear, paidMonth }) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["stagesStatus", paidYear, paidMonth],
		() => residualsCommonService.getStagesStatus({ paidYear, paidMonth }),
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			cacheTime: 0,
			enabled: !!(paidYear && paidMonth),
		},
	);

	return queryResult;
};

export default useGetResidualsStagesStatusQuery;
